import { render, staticRenderFns } from "./WelcomeToTheMoonScoresByDate.vue?vue&type=template&id=79df6290"
import script from "./WelcomeToTheMoonScoresByDate.vue?vue&type=script&lang=ts"
export * from "./WelcomeToTheMoonScoresByDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports